module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBlack.0a569b9.ttf";